import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Route, BrowserRouter as Router, Routes, Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Modal, Button } from 'react-bootstrap';
import config from "../Config";
import "./animations.css"


gsap.registerPlugin(ScrollTrigger);

const Animation5: React.FC = () => {

      const [lgShow, setLgShow] = useState(false);
  
      const [showModal, setShowModal] = useState(false);
      const [modalContent, setModalContent] = useState('');
      const [loading, setLoading] = useState(false);
      const dataUrl = 'https://calendly.com/chris-tcb/portal?primary_color=397ab7'; // Replace with your URL
  
      const handleShow = () => setShowModal(true);
      const handleClose = () => setShowModal(false);

  const racesRef = useRef<HTMLDivElement | null>(null);
  const racesWrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const races = racesRef.current;
    const wrapper = racesWrapperRef.current;
    if (!races || !wrapper) return;

    let tween: GSAPAnimation;
    const scrollSpeed = 1;

    const calculateSlidesPerView = () => {
      const width = window.innerWidth;
      if (width < 576) return 1;
      if (width < 768) return 2;
      if (width < 1200) return 4;
      if (width < 1400) return 4;
      if (width < 1700) return 5;
      if (width < 1900) return 5;
      if (width < 2400) return 5;
      return 4;
    };

const buildAnimation = () => {
  const slidesPerView = calculateSlidesPerView();
  const gap = 0; // px gap between slides
  const sidePadding = 15; // slightly larger padding for safe space

  // Apply padding on both sides
  gsap.set(races, {
    paddingLeft: `${sidePadding}px`,
    paddingRight: `${sidePadding}px`,
  });

  // Calculate slide width properly within available space
  const slideWidth =
    (window.innerWidth - sidePadding * 2 - gap * (slidesPerView - 1)) /
    slidesPerView;

  // Set each slide’s width and margin
  gsap.set(".scroll-item", {
    width: slideWidth,
    marginRight: `${gap}px`,
    flexShrink: 0,
  });

  // Add right margin only for last slide
  gsap.set(".scroll-item:last-child", { marginRight: `${sidePadding}px` });

  if (tween) tween.kill();

  // Create horizontal scroll tween
  tween = gsap.to(races, {
    x: () => {
      const totalWidth = races.scrollWidth;
      const moveX = totalWidth - window.innerWidth + sidePadding * 2;
      return moveX > 0 ? -moveX : 0;
    },
    ease: "none",
  });

  // Single ScrollTrigger for horizontal scroll (no fade triggers for each slide)
  ScrollTrigger.create({
    trigger: wrapper,
    start: "top top",
    end: () => {
      const totalWidth = races.scrollWidth;
      const scrollDistance = totalWidth - window.innerWidth + sidePadding * 2;
      return `+=${scrollDistance}`;
    },
    pin: true,
    scrub: 0.3,
    animation: tween,
    anticipatePin: 1,
    invalidateOnRefresh: true,
  });
};
    

    buildAnimation();

    window.addEventListener("resize", () => {
      ScrollTrigger.getAll().forEach((st) => st.kill());
      buildAnimation();
      ScrollTrigger.refresh();
    });

    // Smooth wheel scroll
    // let isScrolling = false;
    // const onWheel = (e: WheelEvent) => {
    //   e.preventDefault();
    //   if (isScrolling) return;
    //   isScrolling = true;
    //   const delta = e.deltaY * 1.2;
    //   window.scrollTo({ top: window.scrollY + delta, behavior: "smooth" });
    //   setTimeout(() => (isScrolling = false), 50);
    // };
    // window.addEventListener("wheel", onWheel, { passive: false });

    return () => {
      //window.removeEventListener("wheel", onWheel);
      ScrollTrigger.getAll().forEach((st) => st.kill());
      if (tween) tween.kill();
    };
  }, []);

  useEffect(() => {
          if (showModal && !modalContent && !loading) {
            setLoading(true);
            fetch(dataUrl)
              .then(response => response.text()) // Or response.json() if it's JSON
              .then(data => {
                setModalContent(data);
                setLoading(false);
              })
              .catch(error => {
                console.error('Error fetching data:', error);
                setModalContent('Error loading content.');
                setLoading(false);
              });
          }
        }, [showModal, modalContent, loading, dataUrl]);
  
  


  

  return (
     <>
    <div className="racesWrapper portalswiper" ref={racesWrapperRef} style={{ overflow: 'hidden' }}>
     
     <section className='allin-onepayment p-swiper'>
          <div className='container'>
              <div className='row justify-content-md-center'>
                  <div className='col-md-8'>
                      <h6 className='seamless-heading'><span>All-in-one</span> payment portal</h6>
                      <p>Centralize your payment processes with tools that ensure efficiency, security, and ease of use. This suite of features is designed to handle transactions smoothly, from routing to final processing.</p>
                      <a className="book-btn mb-5" onClick={() => setLgShow(true)}>Book a free demo <FontAwesomeIcon icon={faArrowRight} /></a>
                      {/* <a className="book-btn" >Book a free demo <FontAwesomeIcon icon={faArrowRight} /></a> */}
                  </div>
              </div>
          </div>
      </section>



      <div className="races mt-3" ref={racesRef} style={{ display: 'flex', gap: '20px', margin: '0 0 0 15px' }}>
        <div className="scroll-item">
            <div className='slider-swiperbx'>
                <img src="assets/imgs/artboard6.svg" alt="" className='sliderv' />
                {/* <img src="assets/imgs/artboard7.svg" alt="" className='sliderh' /> */}
                <img src="assets/imgs/artboard.svg" alt="" className='smimg' />
                <div className='title'>ACH processing</div>
                <p>ACH transfers can now be processed in real-time, making it the perfect option for those who cannot accept card payments.</p>
            </div>
        </div>
        <div className="scroll-item">
          <div className='slider-swiperbx'>
                <img src="assets/imgs/creditprocessing1.svg" alt="" className='sliderv' />
                {/* <img src="assets/imgs/creditprocessing2.svg" alt="" className='sliderh' /> */}
                <img src="assets/imgs/creditprocessing.svg" alt="" className='smimg' />
                <div className='title'>Credit card processing</div>
                <p>Accept all major card types, from Visa, MasterCard, Discover, American Express, and Apple Pay.</p>
            </div>
        </div>
        <div className="scroll-item">
          <div className='slider-swiperbx'>
                <img src="assets/imgs/batchprocessing1.svg" alt="" className='sliderv' />
                {/* <img src="assets/imgs/batchprocessing2.svg" alt="" className='sliderh' /> */}
                <img src="assets/imgs/batchprocessing.svg" alt="" className='smimg' />
                <div className='title'>Batch processing</div>
                <p>Save time and process large volumes of transactions all at once by uploading CSV files directly to the platform.</p>
            </div>
        </div>
        <div className="scroll-item">
          <div className='slider-swiperbx'>
                <img src="assets/imgs/qrcode1.svg" alt="" className='sliderv' />
                {/* <img src="assets/imgs/qrcode2.svg" alt="" className='sliderh' /> */}
                <img src="assets/imgs/qrcode.svg" alt="" className='smimg' />
                <div className='title'>QR codes</div>
                <p>Scan-to-pay with QR codes for a fast, contactless, and secure checkout experience.</p>
            </div>
        </div>
        <div className="scroll-item">
          <div className='slider-swiperbx'>
                <img src="assets/imgs/invoicing1.svg" alt="" className='sliderv' />
                {/* <img src="assets/imgs/invoicing2.svg" alt="" className='sliderh' /> */}
                <img src="assets/imgs/invoicing.svg" alt="" className='smimg' />
                <div className='title'>Invoicing</div>
                <p>Customize and send invoices electronically, and allow your customers to pay with a card or ACH via a secured payment link.</p>
            </div>
        </div>
        <div className="scroll-item">
          <div className='slider-swiperbx'>
                <img src="assets/imgs/subscriptions1.svg" alt="" className='sliderv' />
                {/* <img src="assets/imgs/subscriptions2.svg" alt="" className='sliderh' /> */}
                <img src="assets/imgs/subscriptions.svg" alt="" className='smimg' />
                <div className='title'>Subscriptions</div>
                <p>Automate your billing cycles with our reliable recurring payment system for subscription-based services.</p>
            </div>
        </div>
        <div className="scroll-item">
          <div className='slider-swiperbx'>
                <img src="assets/imgs/powerfulreporting1.svg" alt="" className='sliderv' />
                {/* <img src="assets/imgs/powerfulreporting2.svg" alt="" className='sliderh' /> */}
                <img src="assets/imgs/powerfulreporting.svg" alt="" className='smimg' />
                <div className='title'>Powerful reporting</div>
                <p>Access detailed reports about your transactions to get valuable insights about your business.</p>
            </div>
        </div>
        <div className="scroll-item">
          <div className='slider-swiperbx'>
                <img src="assets/imgs/paymentterminals1.svg" alt="" className='sliderv' />
                {/* <img src="assets/imgs/paymentterminals2.svg" alt="" className='sliderh' /> */}
                <img src="assets/imgs/paymentterminals.svg" alt="" className='smimg1' />
                <div className='title'>Payment terminals</div>
                <p>Pair our reliable payment terminals with our mobile app in just a few simple steps for added convenience.</p>
            </div>
        </div>
      </div>
    </div>

       <Modal className='potal-mdlbx' centered 
        size="xl"
        show={lgShow}
        onHide={() => setLgShow(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-modal-sizes-title-xl">
        <Modal.Header closeButton>
            <div className='container1'>
                <iframe src="https://calendly.com/chris-tcb/portal?embed_domain=dev.tcbpay.com&embed_type=Inline&primary_color=397ab7&month=2025-09" width="100%" height="680" frameBorder="0" title="Select a Date &amp; Time - Calendly"></iframe>
            </div> 
        </Modal.Header> 
      </Modal>
</>

  );
};

export default Animation5;

